import React from 'react';
import { RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar, ResponsiveContainer, Tooltip } from 'recharts';

export default function ConvictionRadar({ quality = 0, setup = 0, convex = 0, energy = 0, symbol = '' }) {
  // Normalize all to 0-100 scale
  const data = [
    { pillar: 'Quality', value: Math.min(100, Math.max(0, quality)), fullMark: 100 },
    { pillar: 'Setup', value: Math.min(100, Math.max(0, setup)), fullMark: 100 },
    { pillar: 'Convex', value: Math.min(100, Math.max(0, (convex / 5) * 100)), fullMark: 100 },
    { pillar: 'Energy', value: Math.min(100, Math.max(0, (energy / 5) * 100)), fullMark: 100 },
  ];

  return (
    <div style={{ width: '100%', maxWidth: 260, margin: '0 auto' }}>
      {symbol && (
        <div style={{ textAlign: 'center', fontSize: '0.8rem', color: '#F1F5F9', fontWeight: 600, marginBottom: 6 }}>
          {symbol} Pillar Breakdown
        </div>
      )}
      <ResponsiveContainer width="100%" height={220}>
        <RadarChart data={data} cx="50%" cy="50%" outerRadius="70%">
          <PolarGrid stroke="#334155" strokeDasharray="3 3" />
          <PolarAngleAxis
            dataKey="pillar"
            tick={{ fill: '#94A3B8', fontSize: 12, fontWeight: 600 }}
          />
          <PolarRadiusAxis
            angle={90}
            domain={[0, 100]}
            tick={{ fill: '#64748B', fontSize: 9 }}
            axisLine={false}
            tickCount={5}
          />
          <Radar
            name={symbol || 'Score'}
            dataKey="value"
            stroke="#6495ED"
            fill="#6495ED"
            fillOpacity={0.3}
            strokeWidth={2}
          />
          <Tooltip
            contentStyle={{ background: '#1C2640', border: '1px solid #334155', borderRadius: 8, color: '#F1F5F9', fontSize: '0.8rem' }}
            formatter={(value) => [`${Math.round(value)}%`, '']}
          />
        </RadarChart>
      </ResponsiveContainer>
      <div style={{ display: 'flex', justifyContent: 'center', gap: '0.75rem', fontSize: '0.65rem', color: '#94A3B8', marginTop: 2 }}>
        {data.map(d => (
          <span key={d.pillar} style={{ fontFamily: "'JetBrains Mono', monospace", fontWeight: 600 }}>
            {d.pillar}: <span style={{ color: d.value >= 66 ? '#6495ED' : d.value >= 33 ? '#FBBF24' : '#EF4444' }}>{Math.round(d.value)}</span>
          </span>
        ))}
      </div>
    </div>
  );
}
